<template>
    <div v-if="readonly" class="simple-checkbox readonly">
        <div :name="options.field" class="checkbox" :class="{checked:value==='1'}"></div>
    </div>
    <div v-else class="simple-checkbox" :class="{'validate-error':!validateResult}">
        <div
            :name="options.field"
            class="checkbox"
            :class="{checked:value==='1'}"
            @click="clickHandle"
        ></div>
    </div>
</template>

<script>
export default {
    props: {
        options: Object,
        propValue: String,
        rowIndex: Number,
        propReadonly: Boolean
    },

    data() {
        return {
            validateResult: true,
            readonly: this.propReadonly || this.options.readonly,
            field: this.options.field,
            value: this.propValue
        };
    },

    watch: {
        value() {
            this.$emit("change", this.options.field, this.value, this.rowIndex);
        },
        propValue(val) {
            this.value = val;
        }
    },

    methods: {
        clickHandle() {
            this.value = this.value === "1" ? "0" : "1";
        }
    }
};
</script>

<style scoped>
.simple-checkbox {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 10px;
}

.checkbox {
    width: 14px;
    height: 14px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: border 0.2s;
    background-color: #fff;
}

.checkbox.checked {
    background-color: #007aff;
    background-image: url("../../../../img/check-white.png");
    background-repeat: no-repeat;
    background-position: center;
    border: 1px solid #007aff;
}

.checkbox:hover {
    border: 1px solid #007aff;
    box-shadow: 0 0 3px #007aff;
}

.readonly .checkbox {
    background-color: #eee;
}

.readonly .checkbox:hover {
    box-shadow: none;
    border: 1px solid #d9d9d9;
}

.readonly .checkbox.checked {
    background-image: url("../../../../img/check-gray.png");
    background-repeat: no-repeat;
    background-position: center;
    border: 1px solid #d9d9d9;
}
</style>